import { render, staticRenderFns } from "./c_Creator_Events_Item_EventHeader.vue?vue&type=template&id=59e958db&scoped=true&"
import script from "./c_Creator_Events_Item_EventHeader.vue?vue&type=script&lang=js&"
export * from "./c_Creator_Events_Item_EventHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e958db",
  null
  
)

export default component.exports